<template>
    <div class="bigPlayIcon" :style="{color: skin.bigPlay.color}">
        <font-awesome-icon icon="play-circle" :size="size" />
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: 'BigPlayIcon',
        computed:{
            ...mapGetters([
                'skin',
                'played'
            ]),
            size(){
                return this.skin.bigPlay.size + 'x'
            }
        },
        watch:{
            played(newVal){
                if(newVal){
                    const targets = this.$el;
                    this
                        .$anime
                        .timeline()
                        .add({
                            targets,
                            scale: 1.1,
                            duration: 1000,
                            opacity:0,
                            zIndex: '-1',
                            easing: 'easeOutExpo',
                        })
                }
            }
        }
    }
</script>

<style>
    .bigPlayIcon {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;

        position: absolute;
        top: 0;
        left: 0;
        width: 100%;

        z-index: 4500;
    }
</style>